import { Paragraph } from "@/components/ui/Typography";
import type { MicroSite } from "@/lib/api";
const Contact = ({data}:{data: MicroSite}) => {
 if(!data){
    return null;
  };

  const PreviewComponent = () => {
    return (
      <div className="flex relative  flex-col w-full lg:py-4 gap-2  justify-center">   
          <div className="flex items-center gap-3" >
          <Paragraph>{data?.footerSection?.footerAddress}</Paragraph>

          </div>
          <Paragraph>{data?.footerSection?.footerEmail}</Paragraph>
      </div>
    )
  };


  return (
    <div>
       <PreviewComponent />
    </div>
  )
}

export default Contact